
import { createSlice } from '@reduxjs/toolkit'
import { loginUser,signUp, LogOut, GetLogo } from '../api/AuthApi'

const initialState = {
    companyLogo: '',
    loginData: '',
    signupData:[],
    loading:false,
}

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(loginUser.fulfilled , (state, action) => {
        state.loginData=action.payload;
        state.loading = false;
      })
      builder.addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(signUp.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(signUp.fulfilled , (state, action) => {
        state.signupData=action.payload;
        state.loading = false;
      })
      builder.addCase(signUp.rejected, (state, action) => {
        state.loading = false;
      })
      builder.addCase(LogOut.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase(LogOut.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(LogOut.rejected, (state, action) => {
        state.loading = false;
      })

      
      builder.addCase(GetLogo.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase(GetLogo.fulfilled , (state, action) => {
        state.loading = false;
        state.companyLogo = action.payload.data.company_logo;
      })
      builder.addCase(GetLogo.rejected, (state, action) => {
        state.loading = false;
      })
  },

})

 

export default loginSlice.reducer